import { FC, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import queryString from 'query-string';
import { EASSpinner } from 'components/EASSpinner';
import { PATHS } from 'routes/constants';

export const HomePage: FC = () => {
	const { search } = useLocation();
	const navigateParams = queryString.parse(search);

	const navigate = useNavigate();

	useEffect(() => {
		if (navigateParams.code)
			navigate(`${PATHS.AUTH_CODE_PAGE}?code=${String(navigateParams.code)}`);
		else navigate(PATHS.SIGN_IN_PAGE);
	});

	return <EASSpinner />;
};
